import { useState } from "react";
import { supabase } from "./supabase_client";

function ResetPassword({ user, onDone }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }
    if (newPassword.length < 6) {
      setMessage("Password must be at least 6 characters");
      return;
    }

    setSubmitting(true);
    try {
      const { error } = await supabase.auth.updateUser({ password: newPassword });
      if (error) {
        setMessage(error.message);
        return;
      }
      setMessage("Password updated successfully.");
      setNewPassword("");
      setConfirmPassword("");
      window.setTimeout(() => onDone?.(), 1200);
    } catch {
      setMessage("Something went wrong. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  if (!user) {
    return (
      <div className="profile-section">
        <div className="profile-container profile-container--page">
          <div className="profile-header">
            <h1 className="profile-title">Reset password</h1>
          </div>
          <p className="browse-placeholder-text">
            Open the link from your reset email to continue, or request a new link from Sign in → Forgot password.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-section">
      <div className="profile-container profile-container--page">
        <div className="profile-header">
          <h1 className="profile-title">Set new password</h1>
        </div>
        <p className="settings-password-intro">
          Your email link was accepted. Choose a new password below, then you will be signed in with it.
        </p>
        <form className="profile-form" onSubmit={handleSubmit}>
          <div className="profile-input-group">
            <label className="profile-label" htmlFor="reset-new-password">
              New password
            </label>
            <input
              id="reset-new-password"
              type="password"
              className="profile-input"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              autoComplete="new-password"
              required
            />
          </div>
          <div className="profile-input-group">
            <label className="profile-label" htmlFor="reset-confirm-password">
              Confirm new password
            </label>
            <input
              id="reset-confirm-password"
              type="password"
              className="profile-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
              autoComplete="new-password"
              required
            />
          </div>
          <button type="submit" className="profile-save-button" disabled={submitting}>
            {submitting ? "Saving…" : "Update password"}
          </button>
          {message ? (
            <p
              className={`profile-message ${
                message.includes("successfully") ? "profile-message-success" : "profile-message-error"
              }`}
            >
              {message}
            </p>
          ) : null}
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
